import { firstValueFrom } from 'rxjs';

import { AuthService } from '@core/auth/auth.service';

/** After runtime config — restores access from refresh (tab `sessionStorage` or HttpOnly cookie). */
export function authSessionInitializer(auth: AuthService): () => Promise<void> {
  return () => firstValueFrom(auth.hydrateSessionOnStartup());
}
